import { createClient } from '@supabase/supabase-js'

export const supabase = createClient(
  'https://gmrbaijnscgguwrbijjn.supabase.co',
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImdtcmJhaWpuc2NnZ3V3cmJpampuIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzYyNzYxMjcsImV4cCI6MjA5MTg1MjEyN30.0olRE0rasBJTlhkosLeEkllQNHkQAaPxNYXO1k1OKkI',
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
    },
  }
)
